import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  lengthAbbreviation: {
    defaultMessage: 'L',
    id: 'xeSRbz',
    description: 'An abbreviation for the "Length" portion of dimensions (LxWxH)',
  },
  widthAbbreviation: {
    defaultMessage: 'W',
    id: 'REcSZY',
    description: 'An abbreviation for the "Width" portion of dimensions (LxWxH)',
  },
  heightAbbreviation: {
    defaultMessage: 'H',
    id: '57FD48',
    description: 'An abbreviation for the "Height" portion of dimensions (LxWxH)',
  },
});
